import {
  BaseFullSchema_OLD,
  BaseRefSchema,
  BaseCreateSchema,
  BaseUpdateSchema,
  PaginatedResponse,
  IdAsUUID,
} from "./common/commonTypes";
import { UOMTypeRef, UOMUnitRef } from "./uomTypes";

export const ITEM_TYPES = [
  "COMPONENT",
  "SUB_ASSEMBLY",
  "FINISHED_GOOD",
  "SERVICE",
  "SUPPLY",
  "TOOL",
] as const;
export type ItemType = (typeof ITEM_TYPES)[number];

export interface ItemFull extends BaseFullSchema_OLD {
  number: string;
  name: string;
  revision: string;
  catalog_name?: string;
  item_type: ItemType;
  uom_type: UOMTypeRef;
  purchase_uom: UOMUnitRef;
  storage_uom: UOMUnitRef;
  sales_uom: UOMUnitRef;
  default_purchase_price: string;
  default_sales_price: string;
  track_lots: boolean;
  item_expires: boolean;
  item_requires_inspection: boolean;
  minimum_stock: string;
  minimum_stock_base: string;
  maximum_stock: string;
  maximum_stock_base: string;
  notes?: string;
  preferred_bin_id: IdAsUUID;
}

export interface ItemMin extends BaseRefSchema {
  number: string;
  catalog: string | null;
}

export interface ItemRef extends BaseRefSchema {
  number: string;
  name: string;
  revision: string;
  catalog_name?: string;
  item_type: ItemType;
  uom_type: UOMTypeRef;
  purchase_uom: UOMUnitRef;
  storage_uom: UOMUnitRef;
  sales_uom: UOMUnitRef;
}

export interface ItemCreate extends BaseCreateSchema {
  number: string;
  name: string;
  revision: string;
  catalog_name?: string;
  item_type: ItemType;
  uom_type_id: string;
  purchase_uom_id: string;
  storage_uom_id: string;
  sales_uom_id: string;
  preferred_bin_id: string;
  default_purchase_price?: number | string;
  default_sales_price?: number | string;
  track_lots?: boolean;
  item_expires?: boolean;
  item_requires_inspection?: boolean;
  minimum_stock?: number | string;
  maximum_stock?: number | string;
  notes?: string;
}

export interface ItemUpdate {
  id: string;
  number?: string;
  name?: string;
  revision?: string;
  catalog_name?: string;
  item_type?: ItemType;
  uom_type_id?: string;
  purchase_uom_id?: string;
  storage_uom_id?: string;
  sales_uom_id?: string;
  description?: string;
  is_record_active?: boolean;
  default_purchase_price?: number | string;
  default_sales_price?: number | string;
  track_lots?: boolean;
  item_expires?: boolean;
  item_requires_inspection?: boolean;
  minimum_stock?: number | string;
  maximum_stock?: number | string;
  notes?: string;
}

export type PaginatedItemResponse = PaginatedResponse<ItemFull>;
